import React, { useState } from "react";
import styles from "./index.module.scss";

export function ExpandableText(props: { text: string; lines?: number }) {
  const { text, lines = 4 } = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.container}>
      <div
        className={styles.text}
        style={{ WebkitLineClamp: expanded ? "unset" : lines }}
      >
        {text}
      </div>

      {text.length > 120 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className={styles.toggleBtn}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}
